
import Vue from 'vue'
import { USER_LOGGED_IN } from '@/store/getter-types'
import QrCode from 'qrcode.vue'

export default Vue.extend({
  name: 'UserQR',

  components: {
    QrCode
  },

  methods: {

  },

  computed: {
    value (): string {
      return this.$store.getters[USER_LOGGED_IN].getBoarderQRCode
    },
  }
})
